import { useContext, useEffect, useState } from "react";
import UserManagerSingleton from "../../Services/Auth/UserManagerSingleton";
import UserSessionContext, { IUserSessionContext } from "../../Services/Auth/UserSessionContext";
import { useRef } from 'react';
import { configService } from "../../Services/Config/ConfigService";

const userEvents = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'touchmove', 'click', 'scroll']

export const AccessTokenExpiringNotificationTime = 60;

const userIdleTimeoutSec = 60;

/**Redirect to login page */
const invalidateExpiredSession = async (postLogOutRedirectUrl : string) => {
    console.log("Invalidating session...")
    await UserManagerSingleton.getInstance().getOidcUserManager().signoutRedirect({post_logout_redirect_uri: postLogOutRedirectUrl});
}

export const SessionTimeout = () => {
    const userSessionContext : IUserSessionContext = useContext(UserSessionContext);
    const [postLogOutRedirectUrl, setPostLogOutRedirectUrl] = useState("");

    let lastUserActivityTimestampRef = useRef(0);

    const onUserActivity = () => {
        if (lastUserActivityTimestampRef) {
            const now = Date.now();
            lastUserActivityTimestampRef.current = now;
        }
    }

    const userIdleTimeSec = () : number => {
        if (!lastUserActivityTimestampRef) return 0;
        if (lastUserActivityTimestampRef && lastUserActivityTimestampRef.current <= 0) return -1;

        return Math.round((Date.now() - lastUserActivityTimestampRef.current) / 1000);
    }

    useEffect(() => {
        
        async function getPostLogoutRedirectUrl() {
            var configuration = await configService.getConfiguration();
            if (configuration){
                setPostLogOutRedirectUrl(configuration.AbpnIdentity.PostLogoutRedirectUri);
            }
        }

        getPostLogoutRedirectUrl();

    }, [])

    const onAccessTokenExpiring = () => {
        const idleTime = userIdleTimeSec();
        console.log(`Access token expiring... User idle: ${idleTime}sec`);
        if (!userSessionContext.showSessionExpirationWarning && idleTime >= userIdleTimeoutSec) {
            console.log("Showing session expiration warning...");
            userSessionContext.setShowSessionExpirationWarning(true);
        }
    }

    const onAccessTokenExpired = async () => {
        const idleTime = userIdleTimeSec();
        console.log(`Access token expired...User idle: ${idleTime}sec`)

        //Detect whether the user was just recently renewed, if so then cancel reneal
        let isUserExpired = true;
        try{
            const user = await UserManagerSingleton.getInstance().getOidcUserManager().getUser();
            if (user != null){
                if (!user.expired) isUserExpired = false;
            }
        }
        catch (err){
            console.error(err);
        }

        if (!userSessionContext.showSessionExpirationWarning && idleTime < userIdleTimeoutSec) {
            try
            {
                console.log("Refreshing token...")
                UserManagerSingleton.getInstance().getOidcUserManager().signinSilent();
            }
            catch (err) {
                console.error(err);
            }

            return;
        }

        if (isUserExpired) invalidateExpiredSession(postLogOutRedirectUrl);
    }

    useEffect(() => {
        UserManagerSingleton.getInstance().getOidcUserManager().events.addAccessTokenExpiring(onAccessTokenExpiring);
        UserManagerSingleton.getInstance().getOidcUserManager().events.addAccessTokenExpired(onAccessTokenExpired); 

        return () => {
            UserManagerSingleton.getInstance().getOidcUserManager().events.removeAccessTokenExpiring(onAccessTokenExpiring);
            UserManagerSingleton.getInstance().getOidcUserManager().events.removeAccessTokenExpired(onAccessTokenExpired); 
        }

    }, []);

    useEffect(() => {
        userEvents.forEach(ev => document.body.addEventListener(ev, onUserActivity ));

        return () => {
            lastUserActivityTimestampRef.current = 0;
            userEvents.forEach(ev => document.body.removeEventListener(ev, onUserActivity ));
        }
    }, []);

    return <></>;
}

export default SessionTimeout;